import { useContext } from 'react'
import { context } from './context'
import { AppContext } from './Provider'

export default () => {
  const { api } = useContext<AppContext>(context)
  return { api: api.current }
}
